import { render, staticRenderFns } from "./DriversPeriodsUnavailableTypeOverview.vue?vue&type=template&id=67b05012&scoped=true&"
import script from "./DriversPeriodsUnavailableTypeOverview.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodsUnavailableTypeOverview.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodsUnavailableTypeOverview.vue?vue&type=style&index=0&id=67b05012&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b05012",
  null
  
)

export default component.exports